import React from 'react';
import { useAuth } from '../contexts/AuthProvider';
import { useNavigation } from '../contexts/NavigationProvider';
import CloseIcon from './icons/CloseIcon';

const ManagementBanner: React.FC = () => {
    const { managedProfile, stopManaging } = useAuth();
    const { handleNavigation } = useNavigation();

    if (!managedProfile) {
        return null;
    }

    const handleStopManaging = () => {
        stopManaging();
        handleNavigation('feed');
    };

    return (
        <div className="bg-yellow-500 text-black font-semibold text-sm text-center p-2 flex items-center justify-center sticky top-0 z-30">
            <span className="flex-grow text-center">
                You are managing <span className="font-bold">{managedProfile.name}'s</span> profile.
            </span>
            <button
                onClick={handleStopManaging}
                className="flex items-center space-x-1 hover:bg-yellow-600/50 p-1 rounded-full"
                aria-label="Return to your profile"
            >
                <CloseIcon className="h-4 w-4" />
                <span className="hidden md:inline">Return to your profile</span>
            </button>
        </div>
    );
};

export default ManagementBanner;